import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Editor } from '@tiptap/react';

interface NoteEditorContextType {
  activeEditor: Editor | null;
  setActiveEditor: (editor: Editor | null) => void;
  isEditingNote: boolean;
  setIsEditingNote: (editing: boolean) => void;
  activeNoteElement: HTMLElement | null;
  setActiveNoteElement: (element: HTMLElement | null) => void;
}

const NoteEditorContext = createContext<NoteEditorContextType | undefined>(undefined);

export const useNoteEditor = () => {
  const context = useContext(NoteEditorContext);
  return context; // Return undefined if context is not available
};

interface NoteEditorProviderProps {
  children: ReactNode;
}

export const NoteEditorProvider: React.FC<NoteEditorProviderProps> = ({ children }) => {
  const [activeEditor, setActiveEditor] = useState<Editor | null>(null);
  const [isEditingNote, setIsEditingNote] = useState(false);
  const [activeNoteElement, setActiveNoteElement] = useState<HTMLElement | null>(null);

  return (
    <NoteEditorContext.Provider
      value={{
        activeEditor,
        setActiveEditor,
        isEditingNote,
        setIsEditingNote,
        activeNoteElement,
        setActiveNoteElement,
      }}
    >
      {children}
    </NoteEditorContext.Provider>
  );
};